'use client';

import type { GeneralLayout } from '@eliadmin/core/src/api/general/types/general-layout-types';

import type { ReactNode } from 'react';
import { Countdown } from './countdown';
import { isDeadlineActive } from './deadline';

export function HeaderLowerPart({
  generalLayout,
  children,
}: {
  generalLayout: GeneralLayout['data'];
  children: ReactNode;
}) {
  // Must agree with Countdown's own parse, otherwise the bar and the clock
  // inside it can disagree about whether the promo is still running.
  if (!isDeadlineActive(generalLayout?.contact?.eori)) {
    return null;
  }

  return (
    <div className="flex w-full flex-col items-center justify-center gap-2 bg-foreground p-4 lg:p-6">
      {children}
      <Countdown generalLayout={generalLayout} />
    </div>
  );
}
